module.exports = __webpack_public_path__ + "img/jinkaide.png";